import React from "react";
import {
  IonIcon,
  IonRouterLink
} from "@ionic/react";
import {VeterinarioObject} from "../../models/Veterinario";
import fb from "../../lib/firebase";
import {EntityList} from "../../components/EntityListNG";
import {FazendaObject, prepareFazenda} from "../../models/Fazenda";
import {LojaObject} from "../../models/Loja";
import {star} from "ionicons/icons";
import {filtrarColecao} from "../../lib/utils";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {actions} from "../../lib/app";
import FormFazenda from "../Fazendas/FormFazenda/FormFazenda";

interface Props {
  app: AppState;
  dispatch: AppDispatch;
  instance: LojaObject | VeterinarioObject;
  instanceType: 'lojas' | 'veterinarios';
  history: any;
}

interface State {
  loading: boolean;
  colecao: any[];
  colecaoFiltrada: any[];
}

class AbaFazendas extends React.Component<Props, State> {
  private cancelListener: () => void;
  constructor(props:Props) {
    super(props);
    this.state = {
      loading: false,
      colecao: [],
      colecaoFiltrada: [],
    };
    this.cancelListener = () => {};
  }

  componentDidMount() {
    this.installListener();
  }

  componentWillUnmount() {
    this.cancelListener();
  }

  installListener = () => {
    // console.log('installListener');
    this.setState({loading: true});
    let query = fb.db.collection('fazendas')
      .where('owner', '==', this.props.app.user.uid);

    if (this.props.instanceType === 'veterinarios')
      query = query.where('veterinarios', 'array-contains', this.props.instance.id);
    else
      query = query.where('loja.id', '==', this.props.instance.id);

    const _cancelListener = query.orderBy('nome').onSnapshot(snap => {
      const colecao = fb.col(snap).map(prepareFazenda);
      this.setState({colecao, loading: false});
      this.filtrarColecao();
    });
    this.cancelListener = () => {
      // console.log('cancelListener');
      _cancelListener();
    }
  };

  filtrarColecao = (criterio:string='') => {
    this.setState({
      colecaoFiltrada: filtrarColecao(this.state.colecao, criterio, 'nome')
    });
  }

  cardSubtitle = (i: FazendaObject) => (
    <>{i.tipo.join(', ')}</>
  );

  cardTitle = (i: FazendaObject) => (
    <>
      {
        i.matriz &&
        <IonIcon icon={star} className="ml-4 text-4xl float-right text-yellow-400"
                 style={{minWidth: '42px', width: '42px'}}/>
      }
      {i.nome}
    </>
  );

  cardContent = (i: FazendaObject) => (
    <>
      {
        i.veterinario.length > 0 &&
          <div>{i.veterinario.map(i => i.label).join(', ')}</div>
      }

      <div>{i.cidade} ({i.estado})</div>
      {
        i.email &&
        <div>
          <IonRouterLink href={`mailto:${i.email}`}>
            {i.email}
          </IonRouterLink>
        </div>
      }

      {
        i.telefone && <div>{i.telefone}</div>
      }
    </>
  );

  onClickInstance = (instance: FazendaObject) => {
    this.props.dispatch(actions.jump(`/${this.props.instanceType}/${this.props.instance.id}/fazendas`));
    this.props.history.push(`/fazendas/${instance.id}/home`);
  };

  render() {
    return (
      <EntityList
        entityLabel="fazenda"
        colecao={this.state.colecaoFiltrada}
        loading={this.state.loading}
        filtrarColecao={this.filtrarColecao}
        addEnabled={false}
        onClickInstance={this.onClickInstance}
        cardSubTitle={this.cardSubtitle}
        cardTitle={this.cardTitle}
        cardContent={this.cardContent}
        ModelForm={FormFazenda}
      />
    );
  }
}

export default connect(({app}: RootState) => ({app}))(AbaFazendas);